export enum EventTypes {
  RefreshConversation = 'refresh_conversation',
}

export type SSEEventData = {
  conversation_id: string
  created_at: string
  data: {
    user_msg_thread_id: number
  }
  id: string
  message_type: EventTypes
  sender_id: string
}

export type SSEConnectionOptions = {
  url: string
  headers?: Record<string, string>
}
